import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgFlag({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 5a1 1 0 00-1 1v14a1 1 0 11-2 0V6a3 3 0 013-3h12.584a1.2 1.2 0 01.937 1.95L17.28 9l3.24 4.05a1.2 1.2 0 01-.937 1.95H9a1 1 0 110-2h8.92l-2.451-3.063a1.5 1.5 0 010-1.874L17.919 5H7z"
        fill={color}
      />
    </svg>
  )
}

export default SvgFlag
